import type { TranslationDataObj } from './type';

export const data: TranslationDataObj = {
  'app.screen.removed-org': {
    title1: {
      en: 'We are gorry to see you go!',
      fr: 'Nous sommes désolés de vous voir partir !',
    },
    title2: {
      en: 'Delete your account as well?',
      fr: 'Supprimer votre compte également ?',
    },
    description1: {
      en: 'If you change your mind, you can recover your organization within the next 30 days by reaching out to our support team.',
      fr: 'Si vous changez d’avis, vous pouvez récupérer votre organisation dans les 30 prochains jours en nous contactant via notre équipe support.',
    },
    description2: {
      en: 'Seems that you don’t have access to any other organization. ',
      fr: 'Il semble que vous n’avez accès à aucune autre organisation.',
    },
    deleteAccount: {
      en: 'Delete my account',
      fr: 'Supprimer',
    },
    setupNewOrg: {
      en: 'Setup new org.',
      fr: 'Nouvelle organisation',
    },
  },
  'app.screen.no-brand': {
    brandFailed: {
      en: 'Brand creation failed',
      fr: 'Création de marque échouée',
    },
    brandFailedDescription: {
      en: 'Sorry, something didn’t go quite right. Try again to start creating content that matches your brand.',
      fr: 'Désolé, quelque chose n’a pas fonctionné. Réessayer pour commencer à créer du contenu qui correspond à votre marque.',
    },
    setupFirstBrand: {
      en: 'Setup your first brand',
      fr: 'Configurez votre première marque',
    },
    brandCreated: {
      en: 'Brand created',
      fr: 'Marque créée',
    },
    cannotCreateBrand: {
      en: 'Cannot create brand',
      fr: 'Impossible de créer la marque',
    },
  },
};
